import React, { Fragment, memo, useCallback, useEffect, useMemo } from 'react'
import { Droppable } from 'react-beautiful-dnd'
import TodoListItem from './TodoListItem'
import AddItem from '../AddItem'
import Zen from '../Zen'
import LOG from '../../logging/Logger'
import List from '@material-ui/core/List'
import DnDVirtualList from '../lists/DnDVirtualList'
import { isMobile } from 'react-device-detect'
import Typography from '@material-ui/core/Typography'

export default memo(
  ({
    list,
    title,
    scrollRef,
    showAdd = true,
    showAll = true,
    showZen = true,
    hideIfEmpty = false,
    draggable = true,
    textFilter,
    nameFilter,
    descriptionFilter,
    tagsFilter,
    projectFilter,
    current = true,
    future = false,
    sortBy = null,
    droppableId = list,
    hasStatus = true,
    hasList = true,
    getTodos,
    decrypt,
    editTodoStatus,
    getRepeatPattern,
    getProjectNameForTodo,
    redirectToProject,
    getProjectsForAreas,
    clientId,
    createProject,
    deleteTodo,
    getProjectById,
    editTodo,
    getAvailableTags,
    createTodo,
    getAreas,
    getTagsFromTodo,
    cacheDragList,
    setInfo,
    setWarning,
    setError,
    getAreaById,
    createAttachment,
    deleteAttachment,
    editAttachment,
    downloadAttachment,
    getTodoAttachments
  }) => {
    LOG.debug('Render: TodoList: ' + list)

    const todos = useMemo(() => {
      LOG.debug('TodoList', 'Apply filter')
      return getTodos(
        list,
        current,
        future,
        textFilter,
        nameFilter,
        descriptionFilter,
        tagsFilter,
        projectFilter,
        sortBy
      ).filter(todo => showAll || todo.status !== 'done')
    }, [
      list,
      current,
      future,
      textFilter,
      nameFilter,
      descriptionFilter,
      tagsFilter,
      projectFilter,
      sortBy,
      getTodos,
      showAll
    ])

    useEffect(() => {
      cacheDragList(list, todos)
    }, [list, todos, cacheDragList])

    const renderListItem = useCallback(
      ({ index, dragHandleProps, isDragging }) => {
        return (
          <TodoListItem
            draggable={draggable}
            isDragging={isDragging}
            list={todos[index].list}
            todo={todos[index]}
            hasStatus={hasStatus}
            hasList={hasList}
            decrypt={decrypt}
            editTodoStatus={editTodoStatus}
            getRepeatPattern={getRepeatPattern}
            getProjectNameForTodo={getProjectNameForTodo}
            redirectToProject={redirectToProject}
            getProjectsForAreas={getProjectsForAreas}
            clientId={clientId}
            createProject={createProject}
            deleteTodo={deleteTodo}
            getProjectById={getProjectById}
            editTodo={editTodo}
            getAvailableTags={getAvailableTags}
            getAreas={getAreas}
            dragHandleProps={dragHandleProps}
            getTagsFromTodo={getTagsFromTodo}
            getAreaById={getAreaById}
            createAttachment={createAttachment}
            deleteAttachment={deleteAttachment}
            editAttachment={editAttachment}
            downloadAttachment={downloadAttachment}
            getTodoAttachments={getTodoAttachments}
          />
        )
      },
      [
        clientId,
        createProject,
        decrypt,
        deleteTodo,
        draggable,
        editTodo,
        editTodoStatus,
        getAreas,
        getAvailableTags,
        getProjectById,
        getProjectNameForTodo,
        getProjectsForAreas,
        getRepeatPattern,
        hasList,
        hasStatus,
        redirectToProject,
        todos,
        getTagsFromTodo,
        getAreaById,
        createAttachment,
        deleteAttachment,
        editAttachment,
        downloadAttachment,
        getTodoAttachments
      ]
    )

    return (
      <Fragment>
        {(!hideIfEmpty || todos.length > 0) && (
          <Fragment>
            {title && <Typography variant='h6'>{title}</Typography>}

            {showAdd && (
              <Fragment>
                <AddItem
                  list={list}
                  projectId={projectFilter}
                  createTodo={createTodo}
                  todos={todos}
                  decrypt={decrypt}
                  getRepeatPattern={getRepeatPattern}
                  getProjectsForAreas={getProjectsForAreas}
                  clientId={clientId}
                  deleteTodo={deleteTodo}
                  redirectToProject={redirectToProject}
                  getProjectById={getProjectById}
                  createProject={createProject}
                  editTodo={editTodo}
                  getAvailableTags={getAvailableTags}
                  getAreas={getAreas}
                  getTagsFromTodo={getTagsFromTodo}
                  createAttachment={createAttachment}
                  deleteAttachment={deleteAttachment}
                  editAttachment={editAttachment}
                  downloadAttachment={downloadAttachment}
                  getTodoAttachments={getTodoAttachments}
                />
                <br />
                <br />
              </Fragment>
            )}

            {todos.length !== 0 && (
              <DnDVirtualList
                scrollRef={scrollRef}
                rowCount={todos.length}
                renderListItem={renderListItem}
                estimatedRowSize={58}
                isDropDisabled={!draggable}
                droppableId={droppableId}
                isDragDisabled={!draggable}
                getRowData={index => {
                  return index < todos.length ? todos[index] : null
                }}
                disableDragHandle={isMobile}
              />
            )}
            {todos.length === 0 && (
              <Droppable droppableId={droppableId} isDropDisabled={!draggable}>
                {provided => (
                  <List ref={provided.innerRef}>
                    {showZen && <Zen />}
                    {provided.placeholder}
                  </List>
                )}
              </Droppable>
            )}
            <br />
          </Fragment>
        )}
      </Fragment>
    )
  }
)
